import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { QueryHubspotIntegrationTableRowsArgs, Scalars } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = QueryHubspotIntegrationTableRowsArgs;

type TData = Scalars['JSON'];

export const useHubspotIntegrationTableRowsMutation = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query hubspotIntegrationTableRows($tableId: ID!, $format: HubspotTableRowFormatEnum) {
      hubspotIntegrationTableRows(tableId: $tableId, format: $format)
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: async (variables: TVariables): Promise<TData> =>
      await client.request({
        data: {
          gql: graphql,
          variables
        }
      }),
    ...options
  });
};
